import { z } from 'zod';

export const loginSchema = z.object({
  username: z.string().min(1, 'Username is required'),
  password: z.string().min(1, 'Password is required'),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const changePasswordSchema = z
  .object({
    oldPassword: z.string().min(1, 'Old password is required'),
    newPassword: z.string().min(6, 'New password must be at least 6 characters'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });

export type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;

export const forgotPasswordSchema = z
  .object({
    phone: z.string().min(1, 'Phone number is required'),
    otp: z.string().optional(),
    newPassword: z.string().min(6, 'Password must be at least 6 characters'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;

export const registerSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  username: z.string().min(1, 'Username is required'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  phone: z.string().min(1, 'Phone number is required'),
  referralCode: z.string().optional(),
});

export type RegisterFormData = z.infer<typeof registerSchema>;

export const stakeSchema = z.object({
  stakes: z.array(
    z.object({
      label: z
        .string()
        .trim()
        .min(1, 'Label is required')
        .max(8, 'Label must not exceed 8 characters')
        .regex(/^[a-zA-Z0-9]+$/, 'Label must be alphanumeric'),

      value: z
        .number()
        .min(1, 'Value must be greater than 0')
        .max(500000, 'Value must not be greater than 500000'),
    })
  ),
});

export type StakeFormValues = z.infer<typeof stakeSchema>;
